var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacilityKitchenette = function SvgFacilityKitchenette(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80-370v-60h200v-70H160v-60h180v130h110v-296q0-64 45.5-109T605-880q44 0 80 22.5t56 61.5l42 84-55 27-41-83q-12-23-34.5-37.5T604-820q-39 0-66.5 27.5T510-726v296h110v-130h180v60H680v70h200v60zm80 250v-250h60v190h520v-190h60v250z"
  })));
};
export default SvgFacilityKitchenette;